import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { App } from '@/App'
import '@/index.css'
// The app frame, after the utilities. The token layer and the Atlas component
// layer are linked from index.html ahead of the bundle (scripts/sync-design.sh),
// so the order stays tokens -> components -> utilities -> layout.
import '@/styles/app.css'

const root = document.getElementById('root')
if (!root) {
  // Not defensive noise: the SPA-rewrite CloudFront function serves index.html
  // for every extensionless path, so a missing #root means the wrong index.html
  // was published — a deploy fault, not a runtime one, and it should say so.
  throw new Error('#root is missing from index.html — check what was published to the web bucket')
}

createRoot(root).render(
  <StrictMode>
    <App />
  </StrictMode>,
)
